// @flow
import { addMonths, endOfMonth, format, isBefore, parse, startOfMonth } from 'date-fns';

import type { DateRange } from './types';

const dateFormat = 'YYYY-MM-DD';

const multiMonthRangeToSingleMonthRanges = (dateRange: DateRange): Array<DateRange> => {
  const { startDate: startDateString, endDate: endDateString } = dateRange;
  let currentDate = parse(startDateString);
  const endDate = parse(endDateString);
  const monthRanges = [];

  while (isBefore(currentDate, endDate)) {
    monthRanges.push({
      endDate: format(endOfMonth(currentDate), dateFormat),
      startDate: format(startOfMonth(currentDate), dateFormat),
    });

    currentDate = addMonths(currentDate, 1);
  }
  return monthRanges;
};

export default multiMonthRangeToSingleMonthRanges;
